import { render, staticRenderFns } from "./LandpageLayout.vue?vue&type=template&id=aff6e1cc&scoped=true"
import script from "./LandpageLayout.vue?vue&type=script&lang=js"
export * from "./LandpageLayout.vue?vue&type=script&lang=js"
import style0 from "./LandpageLayout.vue?vue&type=style&index=0&id=aff6e1cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff6e1cc",
  null
  
)

export default component.exports